import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sub_scroll_wrap"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "scroll_nav" }

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("ul", _hoisted_3, [
              _createElementVNode("li", {
                class: _normalizeClass({
              on: _ctx.$route.path.includes(_unref(USER_ROUTES).Product.Expert.Expert.Path),
            })
              }, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Expert.Expert.Path}`,
                  alt: "전문가 과정"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode(" 전문가 과정 ")
                  ])),
                  _: 1
                }, 8, ["to"])
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({
              on: _ctx.$route.path.includes(_unref(USER_ROUTES).Product.Expert.Cert.Path),
            })
              }, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Expert.Cert.Path}`,
                  alt: "자격증 관리"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" 자격증 관리 ")
                  ])),
                  _: 1
                }, 8, ["to"])
              ], 2)
            ])
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "prev" }, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("i", { class: "next" }, null, -1))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})